import React from 'react'
import styled from "styled-components"
import { up } from "styled-breakpoints"
import { StaticQuery, graphql } from "gatsby"
import _ from "lodash"

import Carousel from "../../atomic/molecules/Carousel"
import ProjectCard from "../../atomic/organisms/ProjectCard"

class ContentfulBlockSuggestedProjects extends React.Component {

    stack = []

    componentDidMount(){        

        let slug = ''

        if (typeof window !== `undefined`) {
            slug = window.location.pathname.split('/projects/')[1]
        }

        const { data } = this.props
        const { projects } = data
        const { all } = projects

        all.forEach((item, i) => {
            if(item.project.slug !== slug){
                this.stack.push(item.project)
            }
        })

        this.stack = _.shuffle(this.stack)
        this.stack = this.stack.slice(0, 3)

    }

    render() { 

        const { mode, title, accent, data, transition } = this.props
        
        return ( 
            <Container>
              <Projects>
              {this.stack.map((project, i) => (
                  <ProjectCard 
                      key={i}
                      slug={project.slug}
                      client={project.client}
                      title={project.title}
                      image={project.landscapeImage}
                      transition={transition}
                      stacked="vertical"
                  />
              ))}
              </Projects>
              <MobileProjects>
                <Carousel 
                  id={'suggested-projects'} 
                  mode={mode}
                  slidesPerView={1.1}
                  centeredSlides={true}
                  spaceBetween={10}
                >
                {this.stack.map((project, i) => (
                  <ProjectCard 
                      key={i}
                      slug={project.slug}
                      client={project.client}
                      title={project.title}
                      image={project.landscapeImage}
                      transition={transition}
                      mode={mode}
                  />
                ))}
                </Carousel>
              </MobileProjects>
            </Container> 
        )

    }

}

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;

  ${up("md")} {
    
    padding-left:75px;
  }
` 

const Projects = styled.div`
  display:none;

  ${up('md')}{
    display:flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    padding-top: 10vh;
    padding-bottom: 10vh;
  }
`

const MobileProjects = styled.div`
  display:flex;
  width: 100%;
  height: 100%;

  ${up('md')}{
    display:none;
  }
`

const query = graphql`
{
  projects: allContentfulProject(sort: { fields: createdAt, order: DESC }, limit: 100) {
    all:edges {
      project:node {
        slug
        title
        client
        services
        portraitImage{
          fluid(maxWidth: 1200, quality: 100) {
            ...GatsbyContentfulFluid_withWebp
          }
        }
        landscapeImage{
          fluid(maxWidth: 1200, quality: 100) {
            ...GatsbyContentfulFluid_withWebp
          }
        }
      }
    }
  }
}
`

export default props => (
  <StaticQuery
    query={query}
    render={data => <ContentfulBlockSuggestedProjects data={data} {...props} />}
  />
)